import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from "react";
import { GridContext } from "../grid-context";
import * as Styled from "./Col.styled";
export const GridCol = forwardRef((props, ref) => {
    const breakpointContext = useContext(GridContext);
    return _jsx(Styled.Col, { ref: ref, "data-testid": "GridCol", ...props, breakpoints: breakpointContext });
});
GridCol.displayName = "GridCol";
GridCol.defaultProps = Styled.sharedDefaultValues;
